import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

import VisualMediaEmbeds from 'components/property/visual_media_embeds';
import PhotoBulkActions from 'components/photos/bulk_actions';
import { blankVisualMedia, deleteVisualMedia, visualMediaId } from 'components/property/visual_media_shared';
import { Button } from 'components/ui/button';

export default function VisualMediaForm({
  embeds,
  osSection,
  parentName,
  visualMediaTypeOptions,
  onEmbedsChange
}) {
  const [selectedVisualMediaIds, setSelectedVisualMediaIds] = useState([]);

  const visibleEmbeds = embeds.filter(embed => !embed.destroy);
  const embedIds = visibleEmbeds.map(visualMediaId);
  const hasEmbeds = visibleEmbeds.length > 0;
  const allSelected = hasEmbeds && embedIds.every(embedId => selectedVisualMediaIds.includes(embedId));
  const selectedEmbeds = visibleEmbeds.filter(embed => selectedVisualMediaIds.includes(visualMediaId(embed)));

  function handleBulkCheckboxClick(id) {
    if (selectedVisualMediaIds.includes(id)) {
      setSelectedVisualMediaIds(selectedVisualMediaIds.filter(selectedId => selectedId !== id));
    } else {
      setSelectedVisualMediaIds([...selectedVisualMediaIds, id]);
    }
  }

  function handleSelectALl() {
    if (allSelected) {
      setSelectedVisualMediaIds([]);
    } else {
      setSelectedVisualMediaIds(embedIds);
    }
  }

  function handleBulkDelete() {
    const updatedEmbeds = deleteVisualMedia(embeds, selectedVisualMediaIds);

    onEmbedsChange(updatedEmbeds);
    setSelectedVisualMediaIds([]);
  }

  function handleBulkPreview() {
    selectedEmbeds.forEach((embed) => {
      if (embed.embedUrl) window.open(embed.embedUrl, '_blank');
    });
    setSelectedVisualMediaIds([]);
  }

  const bulkActions = (
    <PhotoBulkActions
      allSelected={allSelected}
      disabled={selectedEmbeds.length === 0}
      itemNoun="visual media"
      label="Visual Media"
      osHeader={!!osSection}
      showLimit={false}
      onBulkDelete={handleBulkDelete}
      onBulkPreview={handleBulkPreview}
      onSelectAll={handleSelectALl}
    />
  );

  const embedList = (
    <VisualMediaEmbeds
      mediaTypeOptions={visualMediaTypeOptions}
      osRows={!!osSection}
      parentName={parentName}
      selectedVisualMediaIds={selectedVisualMediaIds}
      visualMediaEmbeds={embeds}
      onBulkCheckboxClick={handleBulkCheckboxClick}
      onChange={onEmbedsChange}
    />
  );

  if (osSection) {
    return osSection(
      <div className="d-flex align-items-center gap-3">
        {hasEmbeds && bulkActions}
        <Button
          icon={faPlus}
          label="Add media"
          type="button"
          variant="ghost"
          onClick={() => onEmbedsChange([...embeds, blankVisualMedia(visualMediaTypeOptions)])}
        />
      </div>,
      embedList,
      hasEmbeds
    );
  }

  return (
    <div className="visual-media-container">
      {bulkActions}
      {embedList}
    </div>
  );
}

VisualMediaForm.propTypes = {
  embeds: PropTypes.array.isRequired,
  osSection: PropTypes.func,
  parentName: PropTypes.string.isRequired,
  visualMediaTypeOptions: PropTypes.array.isRequired,
  onEmbedsChange: PropTypes.func.isRequired
};
